export default __webpack_public_path__ + "static/media/Check Icon.126b594f.svg";